import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function SlickSlider () {
 const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4, // number of cards shown
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      }
    ]
  };

  const cards = [
    { id: 1, title: 'Card 1', content: 'This is card 1' },
    { id: 2, title: 'Card 2', content: 'This is card 2' },
    { id: 3, title: 'Card 3', content: 'This is card 3' },
    { id: 4, title: 'Card 4', content: 'This is card 4' },
    { id: 5, title: 'Card 5', content: 'This is card 5' }
  ];
  return (
     <div style={{ width: '90%', margin: 'auto', padding: '20px' }}>
     
      <Slider {...settings}>
        {cards.map(card => (
          <div key={card.id}>
            <div style={{
              background: '#fff',
              padding: '20px',
              margin: '10px',
              borderRadius: '10px',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
              textAlign: 'center'
            }}>
              <img src='https://img.freepik.com/free-vector/clean-certificate-template-multipurpose-use_1017-31372.jpg' style={{width:"100%",height:"100%"}} />

              <h3 style={{ fontSize: '18px', margin: '10px 0' }}>{card.title}</h3>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}
